import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Label } from '../Label';
import { Stack } from '../Stack';
import { styled } from '../../system';
export const CheckboxLabelGroup = ({ label, helpText, size, children, ...props }) => {
    const hasText = useMemo(() => Boolean(label !== null && label !== void 0 ? label : helpText), [label, helpText]);
    return (_jsxs(StyledContainer, { as: "label", ...props, children: [children, hasText && (_jsxs(Stack, { css: { ml: size === 'sm' ? '$2' : '$3' }, flow: "column", children: [label && (_jsx(StyledLabel, { as: "span", size: size, children: label })), helpText && (_jsx(StyledHelpText, { as: "span", size: size, children: helpText }))] }))] }));
};
const StyledContainer = styled('label', {
    d: 'inline-flex',
    cursor: 'pointer',
    variants: {
        size: {
            sm: {
                textSm: true
            },
            md: {
                textMd: true
            }
        }
    }
});
const StyledLabel = styled(Label, {
    variants: {
        size: {
            sm: {
                textSm: true
            },
            md: {
                textMd: true
            }
        }
    }
});
const StyledHelpText = styled(StyledLabel, {
    color: '$textMuted',
    fontWeight: '$regular'
});
